import { defineMessages } from 'react-intl';
export default defineMessages({
  actionselectSex: {
    id: 'action.selectSex',
    defaultMessage: '请选择性别',
  },
  actioninputNamePrompt: {
    id: 'action.inputNamePrompt',
    defaultMessage: '请输入姓名',
  },
  actionselectBirthday: {
    id: 'action.selectBirthday',
    defaultMessage: '请选择生日',
  },
  actionselectPSW: {
    id: 'action.selectPSW',
    defaultMessage: '请填写交易密码',
  },
  actionselectPSW6: {
    id: 'action.selectPSW6',
    defaultMessage: '请填写6位数交易密码',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/action/index.js